module.exports = __webpack_public_path__ + "img/warning.f9d42f49.png";